import { Link } from "react-router-dom";

export default function PolitiqueConfidentialite() {
    return (
        <div className="max-w-3xl mx-auto px-6 sm:px-10 py-20" data-testid="politique-page">
            <p className="section-tag">vos données</p>
            <h1 className="font-display text-5xl md:text-6xl text-[#2A1408] leading-[0.9] mt-1">
                Politique de confidentialité.
            </h1>

            <div className="mt-10 space-y-8 text-[#3D1F0F] leading-relaxed">
                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Données collectées
                    </h2>
                    <p>
                        Lorsque vous utilisez nos formulaires de contact ou de commande,
                        nous collectons uniquement les informations nécessaires à votre
                        demande : nom, email, téléphone, boutique de retrait, date
                        souhaitée et le contenu de votre message.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Finalités du traitement
                    </h2>
                    <p>
                        Vos données sont utilisées exclusivement pour répondre à votre
                        demande, organiser la préparation de votre commande et vous
                        recontacter si nécessaire. Aucune donnée n'est revendue ni
                        transmise à des tiers à des fins commerciales.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Durée de conservation
                    </h2>
                    <p>
                        Les messages issus du formulaire de contact sont conservés le
                        temps nécessaire au traitement de la demande, puis supprimés au
                        plus tard 12 mois après le dernier échange.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Cookies
                    </h2>
                    <p>
                        Ce site n'utilise pas de cookies de tracking ni de mesure
                        d'audience tiers. Seuls des cookies techniques strictement
                        nécessaires au fonctionnement de l'espace administrateur peuvent
                        être déposés.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Vos droits
                    </h2>
                    <p>
                        Conformément au RGPD, vous disposez d'un droit d'accès, de
                        rectification, d'effacement et d'opposition au traitement de vos
                        données. Pour exercer ces droits, contactez-nous via le
                        formulaire de la page Contact ou par email.
                    </p>
                </section>

                <p className="pt-6">
                    <Link
                        to="/"
                        className="font-handwritten text-2xl text-[#B07B66] hover:text-[#D6552C]"
                    >
                        ← retour à l'accueil
                    </Link>
                </p>
            </div>
        </div>
    );
}
